import type { SVGProps } from 'react';
const DawnFlagCG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-CG_svg__a)">
      <path fill="#F33630" d="M5.238 14.933 20.953 0H22v16H5.238z" />
      <path fill="#009643" d="M16.762 1.067 1.047 16H0V0h16.762z" />
      <path fill="#FCDF4A" d="M23.76-1.647 2.657 20.605-1.112 16.9 19.993-5.352z" />
    </g>
  </svg>
);
export default DawnFlagCG;
